import React, { useState, ChangeEvent, useEffect } from 'react';

interface CheckBoxProps {
    checkboxLabelText?: string;
    checked?: boolean;
    onValueChange?: (value: boolean) => void;
    isDisabled?: boolean;
}

const CheckBox: React.FC<CheckBoxProps> = ({ checked, checkboxLabelText, onValueChange, isDisabled }) => {
    const [checkBoxValue, setCheckBoxValue] = useState(checked || false);

    useEffect(() => {
        setCheckBoxValue(checked || false);
    }, [checked]);

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.checked;
        setCheckBoxValue(newValue);

        if (onValueChange) {
            onValueChange(newValue);
        }
    };

    return (
        <div>
            <div className="checkbox">
                <label>
                    <input
                        disabled={isDisabled}
                        type="checkbox"
                        onChange={handleInputChange}
                        checked={checkBoxValue}
                    />
                    {checkboxLabelText}
                </label>
            </div>
        </div>
    );
};

export default CheckBox;